import { render, staticRenderFns } from "./CardMobileGold.vue?vue&type=template&id=be9726cc&scoped=true&"
import script from "./CardMobileGold.vue?vue&type=script&lang=js&"
export * from "./CardMobileGold.vue?vue&type=script&lang=js&"
import style0 from "./CardMobileGold.vue?vue&type=style&index=0&id=be9726cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9726cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
